import {
  getRolesList,
  createRole,
  updateRole,
  getPermissionByRole,
  deleteRole,
  editPermissions,
  getRoleByKeycloakId,
  getRoleByKeycloakList,
} from "@/http/system/manageRoles.js";

export default {
  namespaced: true,
  state: {
    rolesList: [],
    formError: null,
    clientList: [],
    roleListByKeycloakId: [],
    permissionByRole: {},
  },
  actions: {
    async getRoleByKeycloakId({ commit }, payload) {
      try {
        const resp = await getRoleByKeycloakId(payload);
        commit("SET_ROLES_LIST_BY_CLOAK_ID", resp);
        return resp;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getClientList({ commit }) {
      try {
        const resp = await getRoleByKeycloakList();
        commit("SET_CLIENT_LIST", resp.data);
        return resp;
      } catch (error) {
        throw new Error(error);
      }
    },

    async setRoles({ commit }) {
      try {
        const resp = await getRolesList();
        commit("SET_ROLES", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createRoleAction(_, data) {
      try {
        return await createRole(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateRoleAction(_, data) {
      try {
        return await updateRole(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPermissionsByRole({ commit }, id) {
      try {
        const resp = await getPermissionByRole(id);
        commit("SET_PERMISSIONS_BY_ROLE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editRoleAction(_, data) {
      try {
        return editPermissions(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteRoleAction(_, data) {
      try {
        return await deleteRole(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_ROLES(state, payload) {
      state.rolesList = payload;
    },
    SET_PERMISSIONS_BY_ROLE(state, payload) {
      state.permissionByRole = payload;
    },
    SET_ROLES_LIST_BY_CLOAK_ID(state, payload) {
      state.roleListByKeycloakId = payload;
    },
    SET_CLIENT_LIST(state, payload) {
      state.clientList = payload;
    },
  },
};
